import React from 'react';
import ReactDOM from 'react-dom';

import { LitElement } from '~/lib/bn-lit-element';
import { html, css } from '../js/utility/lit-entity';

export class ParcelLoader extends LitElement {
  constructor() {
    super();
    this._mountedParcelDomElement = undefined;
    this._isMountingParcel = false;
    this._connected = false;
  }

  static get styles() {
    return css`
      .parcel-insertion-point {
        width: var(--parcel-width, 'auto');
        height: var(--parcel-height, 'auto');
      }
    `;
  }

  static get properties() {
    return {
      passThroughProperties: { type: Object },
      parcel: { type: Object },
      parcelIsDialog: { type: Boolean, attribute: 'parcel-is-modal', default: false },
    };
  }

  firstUpdated() {
    this._mountParcel();
  }

  async updated(changedPropertiesMap) {
    // Don't remount the parcel if the pass through property keyValues did not change
    // This handles a new Object being passed in that is a different reference but the same values
    const onlyChangingPassThrough = changedPropertiesMap.has('passThroughProperties') && changedPropertiesMap.size === 1;
    if (onlyChangingPassThrough &&
      JSON.stringify(changedPropertiesMap.get('passThroughProperties')) === JSON.stringify(this.passThroughProperties)) {
      return;
    }

    this._unmountParcel();
    this._mountParcel();
  }

  _unmountParcel() {
    if (!this._isMountingParcel && this._mountedParcelDomElement) {
      ReactDOM.unmountComponentAtNode(this._mountedParcelDomElement);
      this._mountedParcelDomElement = undefined;
      this._isMountingParcel = false;
    }
  }

  _mountParcel() {
    if (this._isMountingParcel) {
      return;
    }

    const domElement = this.shadowRoot.querySelector('.parcel-insertion-point');
    const Parcel = this.parcel;
    const args = {
      ...!this.parcelIsDialog ? { insertionPoint: this.shadowRoot.querySelector('#jss-insertion-point') } : {},
      ...this.passThroughProperties,
    };

    this._isMountingParcel = true;

    ReactDOM.render(
      <Parcel {...args} />,
      domElement,
      () => {
        this._mountedParcelDomElement = domElement;
        this._isMountingParcel = false;
        // Handle the case where the lit component is unmounted before we are done mounting the react component
        if (!this._connected) {
          this._unmountParcel();
        }
      },
    );
  }

  connectedCallback() {
    this._connected = true;
    super.connectedCallback();
  }

  disconnectedCallback() {
    this._connected = false;
    this._unmountParcel();

    super.disconnectedCallback();
  }

  render() {
    return html`
      <noscript id="jss-insertion-point"></noscript>
      <div class="parcel-insertion-point"></div>
    `;
  }
}

window.customElements.define('parcel-loader', ParcelLoader);

